
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password/forgot",
      function () {
        return require("private-next-pages/password/forgot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/password/forgot"])
      });
    }
  